module.exports = __webpack_public_path__ + "static/media/whatsapp.30d44909.svg";